import gsap from 'gsap';
import { module } from 'modujs';
import IS_TOUCH_DEVICE from '../app';

export default class extends module {
    constructor(m) {
        super(m);

        this.onFontsLoadedBind = this.onFontsLoaded.bind(this);
    }

    init() {
        this.bindEvents();

        if (window.isFontsLoaded) {
            this.onFontsLoaded();
        }
    }

    bindEvents() {
        window.addEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    unbindEvents() {
        window.removeEventListener('fontsLoaded', this.onFontsLoadedBind);
    }

    onFontsLoaded() {
        let mm = gsap.matchMedia();
        mm.add('(min-width: 1000px)', () => {
            let targets = gsap.utils.toArray(this.el.querySelectorAll('.c-photos-track'));
            let targets1 = targets.slice(0, targets.length / 2);
            let targets2 = targets.slice(targets.length / 2);
            let tl = gsap.timeline({ repeat: -1 });
            let tlSpeed = 60;

            tl.to(targets1, { yPercent: -100, duration: tlSpeed, ease: 'none' })
                .to(targets2, { yPercent: -100, duration: tlSpeed, ease: 'none' }, `-=${tlSpeed}`)
                .set(targets1, { yPercent: 100 })
                .to(targets2, { yPercent: -200, duration: tlSpeed, ease: 'none' })
                .to(targets1, { yPercent: 0, duration: tlSpeed, ease: 'none' }, `-=${tlSpeed}`)
                .set(targets2, { yPercent: 0 })
                ;
        });
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }
}
